import routerConfig from "srs.sharedcomponents/lib/esm/components/config/routes";
import { routesInfo } from "srs.sharedcomponents/lib/esm/router/routes";

const routesConfig = {
  authenticationRoutes: {
    ...routerConfig.authenticationRoutes,
    "/login": {
      path: "/login",
      component: "ChooseLogin",
      pageTitle: "Login",
    },
    "/retail-login": {
      path: "/retail-login",
      component: "LoginPage",
      pageTitle: "txtLogin",
    },
  },
  publicRoutes: {
    "/service-support": {
      path: "/service-support",
      component: "ServiceSupport",
      pageTitle: "Service Support",
    },
    "/browser-suppliers": {
      path: "/browser-suppliers",
      component: "BrowserSuppliers",
      pageTitle: "Browser Suppliers",
    },
    "/feedback": {
      path: "/feedback",
      component: "ContactUs",
      pageTitle: "Feedback",
    },
  },
  templateUIRoutes: {
    ...routesInfo.reduce<Record<string, { path: string; component: string }>>(
      (acc, { path }) => {
        if (typeof path === "string") {
          acc[path] = {
            path,
            component: "",
          };
        } else if (Array.isArray(path)) {
          path.forEach((item) => {
            acc[item] = {
              path: item,
              component: "",
            };
          });
        }

        return acc;
      },
      {}
    ),
  },
};

export default routesConfig;
